import { useMutation, useQueryClient } from '@tanstack/react-query';

import { getQueryKey as companyNotesGetQueryKey } from '@/components/Note/hooks/useCompanyNotes';
import { getQueryKey as noteGetQueryKey } from '@/components/Note/hooks/useNote';

import type { NoteReminderQueryClientData } from './types';
import { mutationFn } from './mutationFn';
import { getQueryKey as noteRemindersQueryKey } from '../utils';

type Options = {
  onSuccess?: () => void;
};

export const useUpdateNoteReminder = (options: Options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn,
    onSuccess: (data) => {
      const NOTE_REMINDERS_QUERY_KEY = noteRemindersQueryKey(data.entityId);
      queryClient.setQueryData<NoteReminderQueryClientData>(
        NOTE_REMINDERS_QUERY_KEY,
        data
      );
      options.onSuccess?.();
    },
    onSettled: (_, __, { companyId, noteId }) => {
      const COMPANY_NOTES_QUERY_KEY = companyNotesGetQueryKey(companyId);
      const NOTE_REMINDERS_QUERY_KEY = noteRemindersQueryKey(noteId);
      const NOTE_QUERY_KEY = noteGetQueryKey(noteId);

      queryClient.invalidateQueries({ queryKey: COMPANY_NOTES_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: NOTE_REMINDERS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: NOTE_QUERY_KEY });
    },
  });
};
